// ============================================================
// api/emergencyPack.js
// Admin endpoint binding for the emergency-pack consent ceremony
// (business continuity phase 2). Tenant-scoped, admin-tenant only.
// The per-CLIENT push config bindings live in adminClientConfig.js;
// this module is the tenant-level consent half, mirroring
// m365Lifecycle.js exactly.
//
// Backend reference:
//   backend/func-carehub-api/src/functions/admin-tenants-emergency-pack-consent-url.js
//   APIM op: mgmt-admin-tenants-emergency-pack-consent-url
// ============================================================

import { apiPost } from './client';

/**
 * Generate the admin-consent URL for the Document Auth app reg
 * (Sites.Selected) that a client tenant's Global Administrator clicks —
 * Part B of docs/operations/emergency-pack-spo-setup.md. Built server-side
 * from DOCUMENT_AUTH_APP_REG_CLIENT_ID + the Tenant's ExternalTenantID +
 * the MANDATORY explicit redirect_uri (api-domain callback) +
 * state=TenantID (the 2026-07-24 ruling).
 *
 * Throws ApiError(409 document_auth_app_reg_not_configured) while the reg
 *   is not yet created and wired — the EXPECTED state before Part A of the
 *   ceremony, deliberately a 409 not a 500.
 * Throws ApiError(404 tenant_not_found) if the Tenant doesn't exist.
 * Throws ApiError(409 tenant_has_no_external_tenant_id) if the Tenants row
 *   has no client M365 tenant GUID recorded.
 *
 * @param {number} tenantId  Tenants.TenantID
 * @returns {Promise<{ tenantId: number, tenantName: string,
 *   externalTenantId: string, consentUrl: string, note: string }>}
 */
export async function generateEmergencyPackConsentUrl(tenantId) {
  return apiPost(`/mgmt/admin/tenants/${tenantId}/emergency-pack/consent-url`, {});
}
